import React from 'react';
import { CheckCircle, GppGood, Security } from '@mui/icons-material';

const ComplianceBadges = () => {
    const certifications = [
        {
            icon: GppGood,
            title: 'PCI DSS Niveau 1',
            description: 'Certification la plus stricte pour la sécurité des données de paiement',
            status: 'Certifié',
            color: 'green'
        },
        {
            icon: Security,
            title: 'RGPD Conformité',
            description: 'Respect des réglementations européennes sur la protection des données',
            status: 'Conforme',
            color: 'blue'
        },
        {
            icon: CheckCircle,
            title: 'ISO 27001',
            description: 'Système de management de la sécurité de l\'information',
            status: 'Certifié',
            color: 'purple'
        },
        {
            icon: Security,
            title: 'SOC 2 Type II',
            description: 'Contrôles de sécurité, disponibilité, intégrité et confidentialité',
            status: 'Audité',
            color: 'amber'
        }
    ];

    const getStatusColor = (color) => {
        const colors = {
            green: 'bg-green-100 text-green-800',
            blue: 'bg-blue-100 text-blue-800',
            purple: 'bg-purple-100 text-purple-800',
            amber: 'bg-amber-100 text-amber-800'
        };
        return colors[color] || 'bg-gray-100 text-gray-800';
    };

    return (
        <section className="py-16 bg-white">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                <div className="text-center mb-12">
                    <h2 className="text-3xl font-bold text-gray-900 mb-4">
                        Certifications & Conformité
                    </h2>
                    <p className="text-lg text-gray-600 max-w-3xl mx-auto">
                        Netikash respecte les standards de sécurité les plus exigeants
                        de l'industrie des paiements.
                    </p>
                </div>

                <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
                    {certifications.map((cert, index) => (
                        <div key={index} className="text-center group">
                            <div className="bg-gradient-to-br from-amber-50 to-white p-6 rounded-xl border border-amber-100 hover:shadow-lg transition-all duration-300">
                                <div className="w-16 h-16 bg-amber-100 rounded-full flex items-center justify-center mx-auto mb-4 group-hover:scale-110 transition-transform">
                                    <cert.icon className="text-2xl text-amber-600" />
                                </div>

                                <h3 className="text-lg font-semibold text-gray-900 mb-2">
                                    {cert.title}
                                </h3>

                                <p className="text-gray-600 text-sm mb-4">
                                    {cert.description}
                                </p>

                                <span className={`inline-flex items-center px-3 py-1 rounded-full text-xs font-medium ${getStatusColor(cert.color)}`}>
                  {cert.status}
                </span>
                            </div>
                        </div>
                    ))}
                </div>

                {/* Compliance Details */}
                <div className="mt-16 bg-gray-50 rounded-2xl p-8">
                    <h3 className="text-2xl font-bold text-gray-900 mb-6 text-center">
                        Détails de Conformité PCI DSS
                    </h3>
                    <div className="grid md:grid-cols-2 gap-8">
                        <div>
                            <h4 className="font-semibold text-gray-900 mb-4">Exigences Principales</h4>
                            <ul className="space-y-3 text-gray-700">
                                <li className="flex items-center space-x-3">
                                    <CheckCircle className="text-green-500" />
                                    <span>Protection des données des porteurs de cartes</span>
                                </li>
                                <li className="flex items-center space-x-3">
                                    <CheckCircle className="text-green-500" />
                                    <span>Programme de gestion des vulnérabilités</span>
                                </li>
                                <li className="flex items-center space-x-3">
                                    <CheckCircle className="text-green-500" />
                                    <span>Contrôles d'accès stricts</span>
                                </li>
                                <li className="flex items-center space-x-3">
                                    <CheckCircle className="text-green-500" />
                                    <span>Surveillance et tests des réseaux</span>
                                </li>
                            </ul>
                        </div>
                        <div>
                            <h4 className="font-semibold text-gray-900 mb-4">Avantages pour vous</h4>
                            <ul className="space-y-3 text-gray-700">
                                <li className="flex items-center space-x-3">
                                    <CheckCircle className="text-amber-500" />
                                    <span>Réduction des risques de fraude</span>
                                </li>
                                <li className="flex items-center space-x-3">
                                    <CheckCircle className="text-amber-500" />
                                    <span>Confiance accrue de vos clients</span>
                                </li>
                                <li className="flex items-center space-x-3">
                                    <CheckCircle className="text-amber-500" />
                                    <span>Conformité réglementaire assurée</span>
                                </li>
                                <li className="flex items-center space-x-3">
                                    <CheckCircle className="text-amber-500" />
                                    <span>Protection contre les amendes</span>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default ComplianceBadges;